export function getAppOrigin() {
  if (typeof window === 'undefined') return '';
  return window.location.origin.replace(/\/$/, '');
}

export function getAppOriginAndTimezone() {
  const origin = getAppOrigin();
  const timezone =
    typeof Intl !== 'undefined'
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : '';
  return { origin, timezone };
}
